"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PdfFileSource = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _PropTypes = require("./PropTypes");
var _PDF = require("../PDF");
var _PdfFileSource = require("./PdfFileSource.styled");
require("react-pdf/dist/esm/Page/AnnotationLayer.css");
var _hooks = require("../../hooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PdfFileSource = exports.PdfFileSource = function PdfFileSource(_ref) {
  var source = _ref.source;
  var wrapperDiv = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = (0, _react.useState)(source.value.activePage || 1),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    activePage = _useState4[0],
    setActivePage = _useState4[1];
  var _useState5 = (0, _react.useState)(activePage),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    renderedPage = _useState6[0],
    setRenderedPage = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    file = _useState8[0],
    setFile = _useState8[1];
  var url = source.value.url,
    id = source._id;
  var _usePresentationContr = (0, _hooks.usePresentationControl)({}),
    onDocumentLoadSuccess = _usePresentationContr.onDocumentLoadSuccess,
    isDocumentLoaded = _usePresentationContr.isDocumentLoaded;
  (0, _react.useLayoutEffect)(function () {
    setWidth(wrapperDiv.current.getBoundingClientRect().width);
  }, [wrapperDiv]);
  var handleResize = function handleResize(_ref2) {
    var width = _ref2.width;
    setWidth(width);
  };
  (0, _hooks.useResizeObserver)({
    target: wrapperDiv,
    callback: handleResize
  });
  var isLoading = renderedPage !== activePage;
  var handlePageLoading = function handlePageLoading() {
    setRenderedPage(activePage);
  };
  (0, _react.useEffect)(function () {
    setFile(url);
  }, [id]);
  (0, _react.useEffect)(function () {
    var _source$value$activeP;
    setActivePage((_source$value$activeP = source.value.activePage) !== null && _source$value$activeP !== void 0 ? _source$value$activeP : 1);
  }, [source.value.activePage]);
  return /*#__PURE__*/_react["default"].createElement(_PdfFileSource.DocumentWrapper, {
    ref: wrapperDiv
  }, /*#__PURE__*/_react["default"].createElement(_PdfFileSource.PdfWrapper, null, /*#__PURE__*/_react["default"].createElement(_PDF.StudioPDFDocument, {
    file: file,
    onLoadSuccess: onDocumentLoadSuccess,
    className: "document"
  }, isDocumentLoaded && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_PdfFileSource.ActivePage, {
    loading: isLoading,
    pageNumber: activePage ? activePage : 1,
    onRenderSuccess: handlePageLoading,
    className: "page",
    canvasBackground: "#ffffff",
    width: width
  }), renderedPage > 0 && /*#__PURE__*/_react["default"].createElement(_PdfFileSource.RenderedPage, {
    pageNumber: renderedPage,
    className: "prevPage",
    canvasBackground: "#ffffff",
    width: width
  })))));
};
PdfFileSource.propTypes = {
  source: _PropTypes.Source
};